import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
// import Container from 'components/Container';

const Sidebar = ({ open, setOpen }) => {
  const [expand, setExpand] = React.useState(false);

  return (
    <Drawer
      open={open}
      onClose={() => setOpen(!open)}
      anchor="right"
      className="sidebar small-screen"
    >
      <ul className="main-ul">
        <li>
          <Link to="#Features">Features</Link>
        </li>
        <li>
          <Link to="#pricing">Pricing</Link>
        </li>
        <li>
          <Link to="https://screenapp.io/blog/" target="blank">Resources</Link>
        </li>


        {/* <li onClick={() => setExpand(!expand)}>
          <a>Resources</a>
        </li>
        <ul className="dropdown-ul" style={{ height: expand ? 'auto' : 0 }}>
          <li>
            <Link to="/">Blog</Link>
          </li>
          <li>
            <Link to="/">Guides</Link>
          </li>
          <li>
            <Link to="/">FAQ</Link>
          </li>
          <li>
            <Link to="/">Support</Link>
          </li>
        </ul> */}


        <li>
          <Link to="#contact">Contact</Link>
        </li>
      </ul>
    </Drawer>
  );
};

Sidebar.propTypes = {
  // children: PropTypes.node,
};

export default Sidebar;
